/**
 * Documentación:
 * 
 * Este archivo contiene el componente RegistroCivil, que representa un formulario para realizar
 * consultas relacionadas con registros civiles.
 * 
 * El formulario recopila información como el nombre, el apellido paterno, el apellido materno y
 * la fecha de nacimiento de una persona.
 * 
 * Una vez que se completa el formulario y se envía, se realiza una llamada al endpoint del backend
 * '/api/civil' para enviar la información ingresada. Luego, el componente espera la respuesta
 * del backend y llama a la función submitCallback con los resultados obtenidos.
 * 
 * Además, el componente realiza validaciones básicas de los campos antes de enviar la solicitud al backend.
 * Si hay un error durante el proceso de envío de la solicitud o si se recibe una respuesta de error del backend,
 * se maneja el error y se muestra un mensaje de error al usuario.
 */

// Importar React y el hook useState desde la biblioteca 'react'
import React, { useState } from 'react';
import {  useNavigate } from "react-router-dom";
// Definición del componente funcional RegistroCivil
const RegistroCivil = ({ submitCallback }) => {
  // Definir estados locales para cada campo del formulario
  const [nombre, setNombre] = useState('');
  const [primerApellido, setApellidoPaterno] = useState('');
  const [segundoApellido, setApellidoMaterno] = useState('');
  const [fechaNacimiento, setFechaNacimiento] = useState('');
  const [processing] = useState(false); 
  const [error] = useState(null); 
  const navigate = useNavigate() 
  const handleSubmit = (e) => {
    e.preventDefault();
    const url= `/busqueda-civil?nombre=${nombre}&primerApellido=${primerApellido}&segundoApellido=${segundoApellido}&fechaNacimiento=${fechaNacimiento}`
    navigate(url)
    
  };

  // Renderizar el formulario
  return (
    <form className="questionnaire" onSubmit={handleSubmit}>
      {/* Renderizar los campos del formulario */}
      <div className="question">
        <label>
          Nombre:
          <input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Apellido Paterno:
          <input type="text" value={primerApellido} onChange={(e) => setApellidoPaterno(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Apellido Materno:
          <input type="text" value={segundoApellido} onChange={(e) => setApellidoMaterno(e.target.value)} />
        </label>
      </div>
      <div className="question">
        <label>
          Fecha de Nacimiento:
          <input type="text" value={fechaNacimiento} onChange={(e) => setFechaNacimiento(e.target.value)} />
        </label>
      </div>
      {/* Botón de envío del formulario */}
      <button className='button2' type="submit" disabled={processing}>
        {processing ? 'Buscando...' : 'Buscar'}
      </button>

      {/* Mostrar mensaje de error si existe */}
      {error && <div className="error-message">{error}</div>}
    </form>
  );
};

// Exportar el componente RegistroCivil
export default RegistroCivil;
